import Panel from '@mui/lab/TabPanel';
import Tab from '@mui/material/Tab';
import {ReactNode} from 'react';

export interface Result {
  tabs: ReactNode[];
  panels: ReactNode[];
}

export interface TabProps {
  id: number;
  label: string;
  value: string;
  component: ReactNode;
}

const DEFAULT: Result = {
  tabs: [],
  panels: [],
};

export const getTabComponents = (tabs: TabProps[]): Result =>
  tabs.reduce(
    (acc, {id, label, value, component}) => ({
      tabs: [...acc.tabs, <Tab key={id} {...{label, value}} />],
      panels: [
        ...acc.panels,
        <Panel key={id} value={value}>
          {component}
        </Panel>,
      ],
    }),
    DEFAULT,
  );
